import { createContext } from 'react';

const UserPreference = createContext();
export default UserPreference;